/* @flow */

import { em, mix } from 'polished';
import { hoverSelector } from 'src/shared/app/base/style/token/selector';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

const getActiveBackgroundColor = ({
  color,
  theme,
}: ThemeFunction<{ color: string }>) => mix(0.25, color, theme.colorBase);

export default {
  root: {
    display: 'block',
    width: em(24),
    height: em(24),
    transition: '0.15s ease-out',
    color: ({ color }: ThemeFunction<{ color: string }>) => color,
    borderRadius: '50%',
    position: 'relative',

    [hoverSelector]: {
      backgroundColor: (theme: ThemeFunction) =>
        getActiveBackgroundColor(theme),
    },
  },
  active: {
    backgroundColor: (theme: ThemeFunction) => getActiveBackgroundColor(theme),
  },
};
